'use client'

import { UIEvent, useCallback, useRef } from 'react'

type ScrollEndReachedCallback = () => void

export function useInfiniteScroll(
  threshold: number,
  onScrollEndReached: ScrollEndReachedCallback
) {
  const previousPosition = useRef<number>(0)
  const hasTriggered = useRef<boolean>(false)

  const onScroll = useCallback(
    (e: UIEvent<HTMLElement>) => {
      e.stopPropagation()

      const { height } = e.currentTarget.getBoundingClientRect()
      const currentPosition = e.currentTarget.scrollTop + height
      const triggerPosition = e.currentTarget.scrollHeight - threshold

      /* Reset the trigger flag when we scroll back up */
      if (currentPosition < triggerPosition) {
        hasTriggered.current = false
      }

      if (
        currentPosition > triggerPosition &&
        previousPosition.current <= triggerPosition &&
        !hasTriggered.current
      ) {
        hasTriggered.current = true
        onScrollEndReached()
      }

      previousPosition.current = currentPosition
    },
    [threshold, onScrollEndReached]
  )

  return onScroll
}
